// extracted by mini-css-extract-plugin
export default {"label":"WysiwygSection_label__AfLYW","text":"WysiwygSection_text__0hvuA"};